import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import api from '../../services/api';
import { Table, TableBody, TableCell, TableHead, TableRow, Paper, Container, Typography, CircularProgress } from '@mui/material';

const MetalIssueList = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const karigar = params.get('karigar') || '';
  const karat = params.get('karat') || '';
  const [issues, setIssues] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get(`/api/karigar/metal-issue-list?karigar=${karigar}&karat=${karat}`)
      .then(res => setIssues(res.data))
      .catch(() => setIssues([]))
      .finally(() => setLoading(false));
  }, [karigar, karat]);

  return (
    <Container sx={{ py: 4 }}>
      <Typography variant="h4" gutterBottom>Metal Issue List</Typography>
      <Paper>
        {loading ? <CircularProgress sx={{ m: 2 }} /> : (
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Karigar</TableCell>
                <TableCell>Karat</TableCell>
                <TableCell>Amount</TableCell>
                <TableCell>Date</TableCell>
                <TableCell>Remarks</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {issues.length === 0 ? (
                <TableRow><TableCell colSpan={5}>No metal issues found.</TableCell></TableRow>
              ) : issues.map(issue => (
                <TableRow key={issue._id}>
                  <TableCell>{issue.karigarAbbreviation}</TableCell>
                  <TableCell>{issue.karat}</TableCell>
                  <TableCell>{issue.amount}</TableCell>
                  <TableCell>{issue.date}</TableCell>
                  <TableCell>{issue.remarks}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </Paper>
    </Container>
  );
};

export default MetalIssueList;
